import { Link } from "react-router-dom";
import { Icon, cn } from "@project/ui";

export type DashboardBackLinkProps = {
  to: string;
  children: React.ReactNode;
  className?: string;
  /** Para fondos oscuros (p. ej. escaneo con IA). */
  variant?: "default" | "onDark";
};

export function DashboardBackLink({
  to,
  children,
  className,
  variant = "default",
}: DashboardBackLinkProps): JSX.Element {
  return (
    <Link
      to={to}
      className={cn(
        "mb-8 inline-flex items-center gap-2 font-body text-sm font-semibold hover:underline",
        variant === "default" && "text-primary",
        variant === "onDark" && "text-white/90 hover:text-white",
        className,
      )}
    >
      <Icon
        name="ChevronLeft"
        className={cn("size-4 shrink-0", variant === "onDark" && "text-white/90")}
        strokeWidth={1.5}
        aria-hidden
      />
      {children}
    </Link>
  );
}
